import { render, staticRenderFns } from "./SendTemplateDialog.vue?vue&type=template&id=1a74aec4&"
import script from "./SendTemplateDialog.vue?vue&type=script&lang=js&"
export * from "./SendTemplateDialog.vue?vue&type=script&lang=js&"
import style0 from "./SendTemplateDialog.vue?vue&type=style&index=0&id=1a74aec4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports